// @ts-nocheck
import userRequest from '@/utils/request';
import { getToken } from '@/utils/token';
import { encrypt } from '@/utils/encryp';
const reFix = 'useradmin';
const account = 'account';
const user = 'user';
// 用户名搜索f
// export function searchUserNameApi(name){
//     return userRequest({
//         url: reFix + "/Home/lookUser",
//         params: {name},
//         // 跨域 是否携带 cookie
//         withCredentials: true
//     })
// }

// 登录
export function loginApi(params) {
  return userRequest({
    url: reFix + '/Home/login',
    method: 'POST',
    data: params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看用户详细信息，实名数据，银行卡数据
export function getUserModelApi(params) {
  // 内部账号不需要areaId 过滤 禅道bug ID 4184 有备注
  let id = params && params['isInternal'] == 1 ? '' : params.areaId;
  let { userName, mobile } = params;
  // let index1 = str.indexOf('(');
  // let index2 = str.indexOf(')');
  // let str2 = str.substring(index1 + 1, index2);
  // let str1 = str.replace(`(${str2})`, '');
  // return `${decrypt(str1)}(${decrypt(str2)})`;
  let searchName = '';
  if (userName) {
    if (Reflect.has(params, 'isInternal')) {
      searchName = userName;
    } else {
      searchName = encrypt(userName);
    }
  }
  return userRequest({
    url: reFix + '/Home/model',
    params: {
      ...params,
      ...{
        userName: searchName,
        mobile: mobile ? encrypt(mobile) : '',
        // pageIndex: 1,
        // pageSize: 100000,
      },
      areaId: id,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看系统角色
export function getRoleApi() {
  return userRequest({
    url: reFix + '/Home/roles',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查看系统角色
export function getRolesApi() {
  return userRequest({
    url: account + '/Role/RegisterOptionRoleList',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 删除系统角色
export function deleteRolesApi(id) {
  return userRequest({
    url: account + `/Role/${id}`,
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 禁用用户
export function stopUserApi(id) {
  return userRequest({
    url: reFix + `/Home/user`,
    method: 'DELETE',
    params: { userId: id },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 激活用户
export function startUserApi(id) {
  return userRequest({
    url: reFix + `/Home/active`,
    method: 'PUT',
    params: { userId: id },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 修改管理员密码
export function changePasswordApi(data) {
  return userRequest({
    url: reFix + `/Home/userChangePwd`,
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 管理员修改账户密码
export function resetPasswordApi(data) {
  return userRequest({
    url: reFix + `/Home/adminChangePwd`,
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 更改用户身份
export function setRoleApi(roleId, uid) {
  return userRequest({
    url: reFix + `/Home/role`,
    method: 'PUT',
    params: { roleId, userId: uid },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 新增管理员
export function addRolesApi(obj) {
  return userRequest({
    url: reFix + `/Home/user`,
    method: 'POST',
    data: {
      userId: 'string',
      companyId: 'string',
      userCode: 'string',
      userImg: 'string',
      lastPassword: 'string',
      remind: 0,
      status: 0,
      loginTime: '2020-07-16T07:38:29.532Z',
      loginIp: 'string',
      creator: 'string',
      creationTime: '2020-07-16T07:38:29.532Z',
      updater: 'string',
      updationTime: '2020-07-16T07:38:29.532Z',
      description: 'string',
      ...obj,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 更新账号-新
export function editAccountApi(data) {
  return userRequest({
    url: reFix + `/Home/updateUser`,
    method: 'PUT',
    data,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 编辑管理员
export function editRolesApi(obj) {
  return userRequest({
    url: reFix + `/Home/user`,
    method: 'PUT',
    data: {
      userId: 'string',
      companyId: 'string',
      userCode: 'string',
      userImg: 'string',
      lastPassword: 'string',
      remind: 0,
      status: 0,
      loginTime: '2020-07-16T07:38:29.532Z',
      loginIp: 'string',
      creator: 'string',
      creationTime: '2020-07-16T07:38:29.532Z',
      updater: 'string',
      updationTime: '2020-07-16T07:38:29.532Z',
      description: 'string',
      ...obj,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 用户反馈
export function getFeedBackApi(params) {
  return userRequest({
    url: reFix + '/FeedBack',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// ------------------角色管理-----------------------
// 添加角色
export function addRoleApi(data) {
  return userRequest({
    url: account + '/Role',
    method: 'POST',
    data: { ...data },
  });
}
// 编辑角色
export function editRoleApi(data) {
  return userRequest({
    url: account + '/Role/' + data.roleId,
    method: 'PUT',
    data: { ...data },
  });
}
export function getRoleListApi(params) {
  return userRequest({
    url: account + '/Role/RoleList',
    params,
  });
}

export function getRolePageApi(params) {
  return userRequest({
    url: account + '/Role',
    params,
  });
}
export function getRoleAccountApi(params) {
  return userRequest({
    url: account + '/Role/Account',
    params,
  });
}
// 查询账户对应楼盘的权限
export function getRolePermitAccountApi(params) {
  return userRequest({
    url: account + '/Role/Permit/Account',
    params,
  });
}
export function getRolePermitByIdApi(params) {
  return userRequest({
    url: account + '/Role/Permit/' + params.roleId,
    params,
  });
}
export function getRolePermitApi(params) {
  return userRequest({
    url: account + '/Role/Permit',
    params,
    method: 'GET',
  });
}
export function updateRolePermit(data) {
  return userRequest({
    url: account + '/Role/Permit',
    data,
    method: 'PUT',
  });
}
// 更新多楼盘权限
export function updateRolePermitRoleApi(data) {
  return userRequest({
    url: account + '/Role/Permit/' + data.roleId,
    data: data.allNodes,
    method: 'PUT',
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}

// --------------------菜单管理--------------------
export function getMenuApi(params) {
  return userRequest({
    url: account + '/Menu',
    params,
  });
}
export function addMenuApi(data) {
  return userRequest({
    url: account + '/Menu',
    data,
    method: 'POST',
  });
}
export function delMenuApi(data) {
  return userRequest({
    url: account + '/Menu',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
    method: 'DELETE',
  });
}
export function updateMenuApi(data) {
  return userRequest({
    url: account + '/Menu/' + data.menuId,
    data,
    method: 'PUT',
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
export function getMenuPermitApi(params) {
  return userRequest({
    url: account + '/Menu/Permit',
    params,
  });
}
export function updateMenuPermitApi(data) {
  return userRequest({
    url: account + '/Menu/Permit',
    method: 'POST',
    data,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
export function getMenuPermitTreeApi(params) {
  return userRequest({
    url: account + '/Menu/PermitTree',
    params,
  });
}
// ========系统权限===========
// 查询
export function getMenuSmApi(params) {
  return userRequest({
    url: account + `/Menu/SmPermit`,
    params,
    method: 'GET',
    withCredentials: true,
  });
}
// 新增
export function addMenuSmApi(data) {
  return userRequest({
    url: account + `/Menu/SmPermit`,
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  });
}
// 删除
export function delSmPermitApi(data) {
  return userRequest({
    url: account + `/Menu/SmPermit`,
    data,
    method: 'DELETE',
    withCredentials: true,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
}
// 修改
export function updateSmPermitApi(data) {
  return userRequest({
    url: account + `/Menu/SmPermit`,
    data,
    method: 'PUT',
    withCredentials: true,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
// =============功能列表====================
export function getFunctionApi(params) {
  return userRequest({
    url: account + `/Operation`,
    params,
    method: 'GET',
    withCredentials: true,
  });
}
// 新增
export function addFunctionApi(data) {
  return userRequest({
    url: account + `/Operation`,
    method: 'POST',
    data,
    withCredentials: true,
  });
}
// 删除
export function delFunctionApi(data) {
  return userRequest({
    url: account + `/Operation`,
    data,
    method: 'DELETE',
    withCredentials: true,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
}
// 修改
export function updateFunctionApi(data) {
  return userRequest({
    url: account + `/Operation/${data.operationId}`,
    data,
    method: 'PUT',
    withCredentials: true,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
// 查看角色有的功能权限
export function getRoleOperationApi(params) {
  return userRequest({
    url: account + '/Operation/RoleOperation',
    params,
    method: 'GET',
    withCredentials: true,
  });
}
// 修改角色有的功能权限
export function updateRoleOperationApi(data) {
  return userRequest({
    url: account + '/Operation/RoleOperation',
    data,
    method: 'POST',
    withCredentials: true,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
// 查看用户有哪些功能权限
export function getUserOperationApi() {
  return userRequest({
    url: account + '/Operation/Function',
  });
}
// =============获取审批列表==============
export function getExamineListApi(params) {
  return userRequest({
    url: reFix + '/Introduce/Check',
    params,
  });
}
// 审核
export function updateExamineApi(data) {
  return userRequest({
    url: reFix + '/Introduce/Check',
    data,
    method: 'PUT',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
  });
}
// 获取用户状态列表
export function getUserStatusListApi(params) {
  return userRequest({
    url: reFix + '/common/permission_enum_list',
    params,
    method: 'GET',
  });
}
// 获取物业业态枚举
export function getPmcTypeApi() {
  return userRequest({
    url: user + '/PmcIntroduce/pmcType',
    method: 'GET',
  });
}
